module.exports = __webpack_public_path__ + "static/media/Panels__addButton.ca667412.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Panels__addButton.svg
// module id = 600
// module chunks = 0